import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { Instructor } from "../../types/types";
export type LectureByIdDTO = {
  id: string;
  title: string;
  chapterId: string;
  quizId: string;
  createdAt: string;
  updatedAt: string;
  quizizz: QuizDTO[];
  QuizEssay: QuizEssayDTO[];
  Exam: Exam[];
  videos: VideoDTO[];
  resources: Resources[];
  Ifrs: QuizDTO[];
  chapter: Chapter[];
  course: Course;
  instructor: Instructor;
  isDemo?: boolean;
  subscriptionStartsAt?: number | null;
  subscriptionEndsAt?: number | null;
};
type QuizDTO = {
  id: string;
  title: string;
  time: string;
  createdAt: string;
  updatedAt: string;
  isDemo?: boolean;
  videoId?:string | null
};
type QuizEssayDTO = {
  id: string;
  title: string;
  time: string;
  createdAt: string;
  updatedAt: string;
  isDemo?: boolean;
};
type Exam = {
  id: string;
  title: string;
  time: string;
  quizId: string;
  createdAt: string;
  updatedAt: string;
  isDemo?: boolean;
};

type VideoDTO = {
  id: string;
  name: string;
  title: string;
  url: string;
  isDemo?: boolean;
  watched: boolean;
  last: boolean;
  cipher: {
    otp: string;
    playbackInfo: string;
  };

  duration: string;
  lectureId: string;
  createdAt: string;
  updatedAt: string;
};
type Course = {
  id: string;
  name: string;
  description: string;
};
type Chapter = {
  id: string;
  name: string;
  lectures: Lecture[];
  duration: string;
  order: number;
};
type Lecture = {
  id: string;
  title: string;
  duration: string;
  order: number;
};
type Resources = {
  id: string;
  title: string;
  url: string;
  isDemo?: boolean;
};

type getLectureResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: LectureByIdDTO;
};
export const GetLectureById = async (
  lectureId: string
): Promise<getLectureResponse> => {
  try {
    const response = await axios.get(`/lecture/${lectureId}`);
    return { data: response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
